import { Grid, Container } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";
import {
  useOnlineQueryGate,
  ONLINE_QUERIES_OFF_REASON,
} from "../components/General/OnlineQueryGate";

import NewspaperIcon from "@mui/icons-material/Newspaper";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import UploadFileIcon from "@mui/icons-material/UploadFile";
// import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";

export default function NewLegalFile() {
  const { hasPermission } = useAuth();
  const { online } = useOnlineQueryGate();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasPermission("generar novedades expediente") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Generar Novedades"
              subtitle="Generar novedades de expediente consultando SAC"
              icon={<NewspaperIcon />}
              color="#2563eb"
              to="/legalFile/news/generate"
              disabled={!online}
              disabledReason={ONLINE_QUERIES_OFF_REASON}
            />
          </Grid>
        )}

        {hasPermission("ver archivo novedades procesado") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Descargar Novedades"
              subtitle="Descargar novedades en archivo TXT"
              icon={<DescriptionRoundedIcon />}
              color="#0ea5e9"
              to="/legalFile/news/txt"
            />
          </Grid>
        )}

        {hasPermission("importar expediente judicial") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Importar Novedades"
              subtitle="Subir los archivos del exportador local y actualizar jex"
              icon={<UploadFileIcon />}
              color="#16a34a"
              to="/legalFile/judicial/import"
            />
          </Grid>
        )}

        {/* {hasPermission("ver novedades expediente fallido") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Novedades Fallidas"
              subtitle="Ver novedades fallidas"
              icon={<ReportProblemRoundedIcon />}
              color="#ef4444"
              to="/legalFile/news/failed"
            />
          </Grid>
        )} */}
      </Grid>
    </Container>
  );
}
